import React from "react";
import { CompanyLogo } from "../widget/ForgotPasswordWidgets";
import Center from "../../../../widget/common/ui/Center";
import Div from "../../../../widget/common/ui/Div";
import AppTranslation from "../../../../service/app_translation/AppTranslation";
import {
  NewPasswordConfirmField,
  NewPasswordField,
} from "./widget/NewPasswordTextFields";
import { SpacingHeight } from "../../../../widget/common/ui/Spacing";

const NewPasswordContent = (props: { type: number }) => {
  const type: number = props.type;

  return (
    <Div className="h-100 d-center">
      <Div>
        <Center>
          <CompanyLogo title={AppTranslation.text("new_password")} />
        </Center>
        <div style={{ width: 350 }}>
          <form autoComplete="off">
            <NewPasswordField />
            <NewPasswordConfirmField />
          </form>
        </div>
        <SpacingHeight value={type === 3 ? 100 : 20} />
      </Div>
    </Div>
  );
};

export default NewPasswordContent;
